/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import MessageLibraryItemModel from 'cio/models/message-library-item';
import { SortDirection } from 'cio/utils/sort';

export enum SortProperty {
  Name = 'name',
  Status = 'status',
  UpdatedAt = 'updated_at',
  UsedIn = 'used_in',
}

interface MessageLibraryItemsTableArgs {
  query: string;
  // first column arg is to be able to set the value we want to display on the first column. It is different between the two places we use this table.
  firstColumnLabel: string;
  messageLibraryItems: MessageLibraryItemModel[];
  sortBy: SortProperty;
  sortDirection: SortDirection;
  showUpdatedAtColumn?: boolean;
  onSortChange: (sortBy: SortProperty, sortDirection: SortDirection) => unknown;
}

export default class MessageLibraryItemsTable extends Component<MessageLibraryItemsTableArgs> {
  SortDirection = SortDirection;

  get showUpdatedAtColumn() {
    return this.args.showUpdatedAtColumn ?? true;
  }

  get tableHeaders() {
    return [
      { label: this.args.firstColumnLabel, value: SortProperty.Name, class: 'w-4/12', shouldRender: true },
      { label: 'Used in', value: SortProperty.UsedIn, class: 'w-4/12', shouldRender: true },
      { label: 'Status', value: SortProperty.Status, class: 'w-2/12', shouldRender: true },
      { label: 'Updated', value: SortProperty.UpdatedAt, class: 'w-2/12', shouldRender: this.showUpdatedAtColumn },
    ];
  }
}
